/* eslint-disable */
import { bus } from '../../main';
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters
} from 'vuex';
import { VueEditor } from "vue2-editor";
export default {
  name: 'author-details-edit',
  components: {
    VueEditor
  },
  props: [],
  data() {
    return {
      submitted: false,
      courseDetails: '',
      name: '',
      gender: '',
      organization: '',
      location: '',
      course:'',
      courseId:'',
      AuthorDetails:'',
      credential:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',

    }
  },
  computed: {
    ...mapGetters([
      'getAuhtorDetailsByIdDataState',
    ]),
    geAuthorList() {
      this.$store.dispatch('getAuthorDetailsByIdFun', {
        id: this.$route.params.authorId
      }).then((response) => {
        console.log(this.$store.getters.getAuhtorDetailsByIdDataState, "Author Details")
        this.name = this.$store.getters.getAuhtorDetailsByIdDataState.name
        this.gender = this.$store.getters.getAuhtorDetailsByIdDataState.gender
        this.location = this.$store.getters.getAuhtorDetailsByIdDataState.location 
        this.organization = this.$store.getters.getAuhtorDetailsByIdDataState.organization
        this.credential = this.$store.getters.getAuhtorDetailsByIdDataState.credential
      })
    }
  },
  mounted() {
    this.geAuthorList
    this.courseId = this.$route.params.courseId
  },
  methods: {
   createAuthorNamConfirmation(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
              name: this.name,
              gender: this.gender,
              organization: this.organization,
              location: this.location,
              credential: this.credential,
              course:this.$route.params.courseId
          }
          this.$store.dispatch('updateAuthorFun', {
            data:{
              data: data,
              id: this.$route.params.authorId
            }
          })
            .then((res) => {
              toast.success(res.data.msg);
              this.$router.push('/course/' + this.$route.params.courseId + '/author/create/')
            })
            .catch((err) => { })
          return
        }
      });
    }
  }
}